/** TagConditionInput fetchers for the feature-flag dialogs, bound to the
 *  notification-features autocomplete actions (src/api/tagLookups.ts).
 *
 * Deliberately NOT tagCategoriesApi/tagsApi: the tag-admin endpoints demand
 * `console_tag_categories_view`/`console_tags_view`, which a flag-managing
 * user may lack — these actions are gated by the feature-flag perm instead.
 */
import * as tagLookups from '@/api/tagLookups';
import type { TagConditionFetchers } from '@/components/TagConditionInput';

export const tagConditionFetchers: TagConditionFetchers = {
  fetchTenantCategories: (tenantId, q, signal) => tagLookups.tenantCategories(tenantId, q, signal),
  fetchAllCategoryCodes: (q, signal) => tagLookups.categoryCodes(q, signal),
  fetchCategoryTags: (categoryId, q, signal) => tagLookups.categoryTags(categoryId, q, signal),
  fetchTagsForCode: (code, q, signal) => tagLookups.tagsForCode(code, q, signal),
  fetchCanonicalsForCode: (code, q, signal) => tagLookups.canonicalsForCode(code, q, signal),
};
